import { Component, OnInit, ViewChild } from '@angular/core';
import {HttpClient} from '@angular/common/http'
 import * as XLSX from 'xlsx';
import { ExportmisreportService } from '@app/exportmisreport.service';
import { first } from 'rxjs/operators';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-mis-report',
  templateUrl: './mis-report.component.html',
  styleUrls: ['./mis-report.component.css']
})
export class MisReportComponent implements OnInit {
  products = [];  
  tempproducts=[];
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: any = {};
  //dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  
    onloadData(p) {
      console.log("p =",p);
      this.getData(p)
    var i = 0;
    this.msgOnChildCompInit = p;
    this.fromDate = p.fromDatee;
    this.toDate = p.toDatee;
    // alert(p.fromDatee)
    var userId = localStorage.getItem('user_id');
    this.dtOptions = {
      pagingType: 'full_numbers',
      pageLength: 10,
      processing: true,
      dom: 'lBfrtip',
        buttons: [
          { extend: 'excel', text: 'Download Excel' }
        ]
    };
    // this.dtOptions = {
    //   pagingType: 'full_numbers',
    //   pageLength: 10,
    //   processing: true
    // };
    //this.verifyDocService.getVerificationDocsSuperVerifier( this.fromDate, this.toDate)
    // this.MisReportService.getDetails(this.fromDate, this.toDate)
    this.MisReportService.getDetails(p.fromDatee, p.toDatee)
      .pipe(first())
      .subscribe(
        data => {
          console.log("response---", data)
            this.dtTrigger.next();
        },
        error => {
          console.log(error)
        })
  }
  constructor(private MisReportService:ExportmisreportService) {}
  fullData : any;
  urlData: any;
  gendate: any;
  dategen: any;
  fromDate: any;  
  toDate: any;
  fromdate: any;
  msgOnChildCompInit: String="";
  msgOnButtonClick: String="";


  ngOnInit(){
 //   this.getexportexcel();
  }
 
  

  
  title = 'ExportTable';
  fileName= 'ExcelSheet.xlsx';

  getexportexcel(){
    console.log(this.fromDate,this.toDate)
    this.MisReportService.getDetails(this.fromDate, this.toDate).subscribe(data => {

      console.log("--data--",data)

      this.urlData = data
      this.fullData = this.urlData.respData
       console.log("API data", this.fullData)
       this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
        dtInstance.destroy();
        this.dtTrigger.next();
      });
      })
 }

 getData(p) {
  console.log(p.fromDatee,p.toDatee)
  this.msgOnButtonClick = p;
  //alert('this.msgOnButtonClick  '+this.msgOnButtonClick);
  this.MisReportService.getDetails(p.fromDatee, p.toDatee).subscribe(data => {

    console.log("--data--",data)

    this.urlData = data
    this.fullData = this.urlData.respData
     console.log("API data", this.fullData)
     this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
    })
  
  
}

   headers = ["ID", "First Name", "Last Name", "Stream Name", "Branch Name","Semester", "Year", "Seat No.", 
   "Email Id", "Contact No.", "Company Name", "Payment Date", "Total Amt", "Univ Amt", "Security Amt", "GST", 
   "Actual Status", "Month Of Passing", "Doc Status", "Bucket", "Close Date", "Transaction Id", "Remark"]
  

   
  // exportexcel(): void
  //  {
  // //   /* pass here the table id */
  //    let element = document.getElementById('excel-table');
  //    const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  // //   /* generate workbook and add the worksheet */
  //    const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
  // //   /* save to file */  
  //    XLSX.writeFile(wb, this.fileName);
 
  //  }

}
